import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";
import { message } from 'antd';

// load -------------------------------------------------------------
const get = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/settings/', method: 'get', headers: authHeader(), data: 1
    }).catch(function (error) {
        console.log(error.response?.data);
    })
}

// save -------------------------------------------------------------
const save = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/settings/', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response?.data);
    })
}

/* -------------------------------------------------------------------------------- *\
|                               setDebug
\* -------------------------------------------------------------------------------- */
const setDebug = async (active) =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/debug/' + (active ? 'active' : 'notactive'), method: 'get', headers: authHeader() })
        .catch(function (error) { message.warning(error.response?.data); })
}
/* -------------------------------------------------------------------------------- *\
|                               getDebug
\* -------------------------------------------------------------------------------- */
const getDebug = async () =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/debugmode', method: 'get', headers: authHeader() })
        .then(response => response.data)
        .catch(function (error) { message.warning(error.response?.data); })
}
/* -------------------------------------------------------------------------------- *\
|                               getMccMncCountries
\* -------------------------------------------------------------------------------- */
const getMccMncCountries = async () =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/mcc-mnc-countries', method: 'get', headers: authHeader() })
        .then(response => response.data)
        .catch(function (error) { message.warning(error.response?.data); })
}
/* -------------------------------------------------------------------------------- *\
|                               saveMccMncCountries
\* -------------------------------------------------------------------------------- */
const saveMccMncCountries = async (countries) =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/mcc-mnc-countries', method: 'post', headers: authHeader(), data: { countries } })
        .catch(function (error) { message.warning(error.response?.data); throw error; })
}
/* -------------------------------------------------------------------------------- *\
|                               uploadReportLogoV2
|   Upload a customer logo image; returns { path } (absolute server path).
\* -------------------------------------------------------------------------------- */
const uploadReportLogoV2 = async (file) =>
{
    const formData = new FormData();
    formData.append('file', file);
    return await axios({ url: getmainurl() + '/api/v1/settings/report-logo-v2', method: 'post', headers: authHeader(), data: formData })
        .then(response => response.data)
        .catch(function (error) { message.warning(error.response?.data); throw error; })
}
/* -------------------------------------------------------------------------------- *\
|                               getReportLogoV2Url
|   Build the (tokenless) URL serving a customer logo, given its path or filename.
\* -------------------------------------------------------------------------------- */
const getReportLogoV2Url = (pathOrName) =>
{
    if (!pathOrName) return '';
    const name = pathOrName.split(/[\\/]/).pop();
    return getmainurl() + '/api/v1/settings/report-logo-v2/' + encodeURIComponent(name);
}
/* -------------------------------------------------------------------------------- *\
|                               getLogs
\* -------------------------------------------------------------------------------- */
const getLogs = async (log, nbline) =>
{
    return axios({ url: getmainurl() + '/api/v1/settings/logs/' + log + "/" + nbline, method: 'get', headers: authHeader() })
        .then(response => response.data)
}

/* -------------------------------------------------------------------------------- *\
|                               getReportConfig
\* -------------------------------------------------------------------------------- */
const getReportConfig = async () =>
{
    return axios({ url: getmainurl() + '/api/v1/settings/report-config', method: 'get', headers: authHeader() })
        .catch(function (error) { console.log(error.response?.data); throw error; })
}
/* -------------------------------------------------------------------------------- *\
|                               getReportMode
\* -------------------------------------------------------------------------------- */
const getReportMode = async () =>
{
    return axios({ url: getmainurl() + '/api/v1/settings/report-mode', method: 'get', headers: authHeader() })
        .then(response => response.data?.reportMode || 'None')
        .catch(function (error) { console.log(error.response?.data); return 'None'; })
}
/* -------------------------------------------------------------------------------- *\
|                               saveReportConfig
\* -------------------------------------------------------------------------------- */
const saveReportConfig = async (data) =>
{
    return axios({ url: getmainurl() + '/api/v1/settings/report-config', method: 'post', headers: authHeader(), data: data })
        .catch(function (error) { console.log(error.response?.data); throw error; })
}

// default export ---------------------------------------------------
const settings = {
    get,
    save,
    setDebug,
    getDebug,
    getMccMncCountries,
    saveMccMncCountries,
    uploadReportLogoV2,
    getReportLogoV2Url,
    getLogs,
    getReportConfig,
    getReportMode,
    saveReportConfig
};

export default settings;